import { render, staticRenderFns } from "./valid_message.vue?vue&type=template&id=1110f328&"
import script from "./valid_message.vue?vue&type=script&lang=js&"
export * from "./valid_message.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports